import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';
import { Drawer, Button, Row, Icon, Divider, message, Col } from 'antd';

//import WrappedSettingForm from './SettingForm';
import WrappedSheaderForm from './form/SheaderForm';
import WrappedSsubHeaderForm from './form/SsubHeaderForm';
import WrappedSukuranFontForm from './form/SukuranFontForm';
import WrappedSslideForm from './form/SslideForm';
import SlogoForm from './form/SlogoForm';
import WrappedSglobalForm from './form/SglobalForm';

class SettingDrawer extends PureComponent {

    state = {
        visible: false,
        childDrawer: {
            visible: false,
            title: '',
            content: ''
        }
    };

    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };

    showChildDrawer = (param) => {
        this.setState({
            childDrawer: {
                visible: true,
                title: param.title,
                content: param.content
            }
        })
    }

    childDrawerOnClose = () => {
        this.setState({
            childDrawer: {
                visible: false
            }
        })
    }

    onClose = () => {
        this.props.onClose();
    };

    onReload = () => {
        window.location.reload();
    }

    settingHeaderOnClick = () => {
        let headerParam = {
            title: 'Setting Header',
            content: 'sheader'
        };
        this.showChildDrawer(headerParam);
    }

    settingSubHeaderOnClick = () => {
        let headerParam = {
            title: 'Setting Sub Header',
            content: 'ssheader'
        };
        this.showChildDrawer(headerParam);
    }

    settingSukuranFontOnClick = () => {
        let headerParam = {
            title: 'Setting Ukuran Font Slide',
            content: 'sukuranfont'
        };
        this.showChildDrawer(headerParam);
    }

    settingSslideOnClick = () => {
        let headerParam = {
            title: 'Setting Slide',
            content: 'sslide'
        };
        this.showChildDrawer(headerParam);
    }

    settingLogoOnClick = () => {
        let headerParam = {
            title: 'Setting Logo',
            content: 'slogo'
        };
        this.showChildDrawer(headerParam);
    }

    setFullScreen = () => {
        this.launchIntoFullscreen(document.documentElement);
    }

    settingGlobalOnClick = () => {
        let headerParam = {
            title: 'Global Setting',
            content: 'sglobal'
        };
        this.showChildDrawer(headerParam);
    }

    launchIntoFullscreen = (element) => {
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    }

    exitFullscreen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }

    resetLokalSetting = () => {
        let lokalSetting = localStorage.getItem('configApp');
        if(typeof lokalSetting != 'undefined'){
            localStorage.removeItem('configApp');
        }
        message.success("Setting berhasil di reset silahkan reload.")
    }

    render() {
        return (
            <div>
                <Drawer
                    title={<div><Icon type="setting" /><span> </span>Konfigurasi</div>}
                    width={400}
                    closable={false}
                    onClose={this.onClose}
                    visible={this.props.visible}
                >
                    {/* <WrappedSettingForm/> */}
                    <ChildDrawer
                        title={this.state.childDrawer.title}
                        onClose={this.childDrawerOnClose}
                        visible={this.state.childDrawer.visible}
                        content={this.state.childDrawer.content}
                    />
                    {/* <Row style={style}>
                        <ButtonSetting onClick={this.settingLogoOnClick} text="Logo Rumah Sakit" />
                    </Row> */}
                    {/* <Row style={style}>
                        <ButtonSetting onClick={this.settingHeaderOnClick} text="Nama Rumah Sakit" />
                    </Row>
                    <Row style={style}>
                        <ButtonSetting onClick={this.settingSubHeaderOnClick} text="Alamat Rumah Sakit" />
                    </Row> */}
                    <Row style={style}>
                        <Col span={24}>
                            <ButtonSetting onClick={this.settingGlobalOnClick} text="Global Setting" />
                        </Col>
                    </Row>
                    <Divider />
                    <Row style={style}>
                        <ButtonSetting onClick={this.settingSukuranFontOnClick} text="Ukuran Font" />
                    </Row>
                    <Row style={style}>
                        <ButtonSetting onClick={this.settingSslideOnClick} text="Slide" />
                    </Row>
                    <Row style={style}>
                        <ButtonSetting
                            onClick={this.setFullScreen}
                            text="Fullscreen"
                        />
                    </Row>
                    <Row style={style}>
                        <ButtonSetting
                            onClick={this.exitFullscreen}
                            text="Exit Fullscreen"
                        />
                    </Row>
                    <Row style={style}>
                        <ButtonSetting
                            onClick={this.resetLokalSetting}
                            text="Reset Lokal Setting"
                        />
                    </Row>

                    <ActionBottom onCancel={this.onClose} onReload={this.onReload} />
                </Drawer>
            </div>
        );
    }
}

const style = {
    marginBottom: 10
};

const getChildDrawerContent = (content) => {
    let childContent;
    switch (content) {
        case 'sheader':
            childContent = <WrappedSheaderForm />
            break;
        case 'ssheader':
            childContent = <WrappedSsubHeaderForm />
            break;
        case 'sukuranfont':
            childContent = <WrappedSukuranFontForm />
            break;
        case 'sslide':
            childContent = <WrappedSslideForm />
            break;
        case 'slogo':
            childContent = <SlogoForm />
            break;
        case 'sglobal':
            childContent = <WrappedSglobalForm />
            break;
        default:
    }
    return <div>{childContent}</div>
}

const ChildDrawer = (props) => {
    return <Drawer
        width={500}
        title={props.title}
        onClose={props.onClose}
        visible={props.visible}
    >
        {getChildDrawerContent(props.content)}
    </Drawer>
}

const ButtonSetting = (props) => {
    return <Button
        style={{
            width: '100%'
        }}
        //icon="setting"
        onClick={props.onClick}>{props.text}</Button>
}

const ActionBottom = (props) => {
    return <div
        style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
        }}
    >
        <Button
            style={{
                marginRight: 8,
            }}
            onClick={props.onCancel}
        >
            Cancel
    </Button>
        <Button onClick={props.onReload} type="primary">
            Reload
        </Button>
    </div>
}

SettingDrawer.propTypes = {

};

export default SettingDrawer;